/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Irreversible_Warning_TitleInputs */



/**
* | output |
* | --- |
* | "Irreversible actions without asking" |
*
* @param {Agent_Irreversible_Warning_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_irreversible_warning_title = /** @type {((inputs?: Agent_Irreversible_Warning_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Irreversible_Warning_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unumkehrbare Aktionen ohne Rückfrage")
	return /** @type {LocalizedString} */ ("Irreversible actions without asking")
});